import sample from 'lodash-es/sample';
import HttpStatus from 'http-status-codes';
import fixtures from './fixtures';
import { getBusinessDates } from '@utils/date';

import { SERVICE_TYPES } from '@services/minte';

function createError(status) {
  return {
    response: {
      status
    }
  };
}

function createResult(data) {
  return {
    result: data
  };
}

function createApi() {
  return {
    loginWithEmail: async ({ email, password }) => {
      const { user } = fixtures;
      if (user.email === email && user.password === password) {
        return createResult({
          authToken: 'test',
          refreshToken: 'test'
        });
      }

      throw createError(HttpStatus.ACCESS_UNAUTHORIZED);
    },
    reigsterWithEmail: async () => {
      return createResult({
        authToken: 'test',
        refreshToken: 'test'
      });
    },
    checkEmailAvailability: async ({ email }) => {
      const { user } = fixtures;
      if (user.email === email) {
        throw createError(HttpStatus.BAD_REQUEST);
      }

      return createResult({
        available: true
      });
    },
    getAuthToken: async ({ authToken, refreshToken }) => {
      return createResult(authToken);
    },
    getAppData: async () => {
      const { staticAppData } = fixtures;
      return createResult(staticAppData);
    },
    getUserProfile: async () => {
      const { user } = fixtures;
      return createResult(user);
    },
    getProperties: async () => {
      const { propertiesList } = fixtures;
      return createResult(propertiesList);
    },
    assignProperty: async () => {
      return createResult(23);
    },
    getMyCleans: async month => {
      const { cleans } = fixtures;
      const rows = getBusinessDates(month);
      const totalDays = rows.reduce((acc, row) => acc.concat(row.days), []);
      const shuffled = totalDays.sort(() => 0.5 - Math.random());
      let selected = shuffled.slice(0, cleans.length);

      return createResult(
        cleans.map((item, index) => {
          const { additionalService, ...rest } = item;
          const momentDate = selected[index];
          const selector = Math.floor(Math.random() * 5);

          const shuffledAddons = additionalService.sort(
            () => 0.5 - Math.random()
          );

          let selectedAddons = shuffledAddons.slice(
            0,
            sample([0, 1, 2, 3, 4], 1)
          );

          const newItem = {
            ...rest,
            serviceDate: momentDate.format(),
            additionalService: selectedAddons,
            serviceType:
              selector >= 2
                ? SERVICE_TYPES.HOTEL_STYLE
                : SERVICE_TYPES.DEEP_CLEAN
          };
          return newItem;
        })
      );
    },
    getKeyReleaseInfo: async () => {
      const { keyReleaseInfo } = fixtures;
      return createResult(keyReleaseInfo);
    },
    getAvailableDates: async () => {
      const { availableDates } = fixtures;
      return createResult(availableDates);
    },
    setKeyReleaseInfo: async () => {
      return createResult(true);
    },
    addPayment: async body => {
      return createResult(body);
    },
    getCostCalculations: async () => {
      return createResult({});
    },
    getRecurringCostCalculations: async () => {
      return createResult({});
    },
    createBooking: async () => {
      return createResult({});
    },
    createRecurringBooking: async () => {
      return createResult({});
    },
    updateBasicProfile: async () => {}
  };
}

const apiClient = createApi();

export default apiClient;
